
.adSearchLink {
  padding: 32px 0 16px;
  border-top: 1px solid rgb(255, 255, 255, 0.2);
  
  .addSearchLinkAction {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    cursor: pointer;
  }

  .adSearchLinkIcon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--primitives-colors-neutral-970);
  }

  .adSearchLinkText {
    font: var(--font-body-md-medium);
    color: var(--primitives-colors-neutral-0);
  }

  .adSearchLinkBtn {
    margin-left: 12px;
  }
}